import { SearchCriteria } from "../search-criteria";

export class GetNationalitiesCriteria extends SearchCriteria {
}
